export default [
  '$uibModalInstance',
  'userService',
  function ($uibModalInstance, userService) {
    this.saveDraft = () => $uibModalInstance.close('saveDraft');
    this.isUserWithLimitedBalance = !!userService.user.limitedBalance;
    this.getTitle = () => {
      if (this.isUserWithLimitedBalance) {
        return 'Недостаточно средств на счёте';
      }

      return 'Недостаточно средств на счёте агентства';
    };

    this.getFirstLine = () => {
      if (this.isUserWithLimitedBalance) {
        return 'Чтобы разместить объявление, необходимо пополнить счёт.';
      }

      return 'Чтобы разместить объявление, необходимо пополнить счёт агентства.';
    };
  },
];
